export default "__VITE_ASSET__3ba26ac1__"